<div data-cy="closable-snackbar__page" class="flex">
  <div>{{ data?.message }}</div>
  <mat-icon data-cy="closable-snackbar__icon-btn" (click)="snackBarRef.dismiss()">cancel</mat-icon>
</div>

